import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Open+Sans'],
  },
});
